export const GET_COMPANY_EVENT_REQUESTS_REQUEST =
  "GET_COMPANY_EVENT_REQUESTS_REQUEST";
export const GET_COMPANY_EVENT_REQUESTS_RESPONSE =
  "GET_COMPANY_EVENT_REQUESTS_RESPONSE";
export const GET_COMPANY_EVENT_REQUESTS_SUMMARY_RESPONSE =
  "GET_COMPANY_EVENT_REQUESTS_SUMMARY_RESPONSE";
export const BULK_APPROVE_COMPANY_EVENT_REQUESTS_REQUEST =
  "BULK_APPROVE_COMPANY_EVENT_REQUESTS_REQUEST";
export const BULK_REJECT_COMPANY_EVENT_REQUESTS_REQUEST =
  "BULK_REJECT_COMPANY_EVENT_REQUESTS_REQUEST";
export const BULK_ALLOCATE_COMPANY_EVENT_REQUESTS_REQUEST =
  "BULK_ALLOCATE_COMPANY_EVENT_REQUESTS_REQUEST";
export const BULK_UNASSIGN_COMPANY_EVENT_REQUESTS_REQUEST =
  "BULK_UNASSIGN_COMPANY_EVENT_REQUESTS_REQUEST";
export const BULK_REMOVE_COMPANY_EVENT_REQUESTS_REQUEST =
  "BULK_REMOVE_COMPANY_EVENT_REQUESTS_REQUEST";
export const BULK_CHANGE_ROLE_COMPANY_EVENT_REQUESTS_REQUEST =
  "BULK_CHANGE_ROLE_COMPANY_EVENT_REQUESTS_REQUEST";
